module.exports = "https://static.energy5.com/_next/static/images/brand3-b79f23c8e2f7f4d377113ea9cd7af508.png";